import React from "react";
import { Chip, Typography } from "@mui/material";
import { getBadgeStyles, getAlmacenColor } from "../../../../components/ui/badgeColors";
import { useAlmacenes } from "../../hooks/useAlmacenes";

/**
 * Chip de almacén con su nombre ("Nave 1") y el color corporativo del almacén.
 * Si el código es null, muestra "Sin asignar" en gris.
 */
const AlmacenChip = ({ codigo, estilos }) => {
    const { getNombreAlmacen } = useAlmacenes();

    // Inventarios sin almacén asignado (almacen = null en el backend)
    if (!codigo) {
        return (
            <Typography sx={{ fontSize: 13, color: "#6c757d" }}>
                Sin asignar
            </Typography>
        );
    }

    return (
        <Chip
            label={getNombreAlmacen(codigo)}
            size="small"
            sx={getBadgeStyles(getAlmacenColor(codigo), estilos)}
        />
    );
};

export default React.memo(AlmacenChip);
